import { request } from "@/plugins/request";
import { getCookie } from "@/utils";
import { ACCESS_TOKEN_COOKIE_NAME } from "@/constants";

const state = {
  user: null,
  access_token: getCookie(ACCESS_TOKEN_COOKIE_NAME) || null,
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN(state, token) {
    state.access_token = token;
  },
};

const actions = {
  async getMe({ commit, state, dispatch }) {
    // если нет токена то пробуем
    // его получить по рефрешу
    if (!state.access_token) {
      await dispatch("renewToken", {
        ignoreAuthError: true,
        noAuthRedirect: true,
      });
    }
    const { data } = await request({
      url: "/users/me/",
      noAuthRedirect: true,
    });
    if (data.id) {
      commit("SET_USER", data);
      return data;
    } else {
      throw new Error("not authorized");
    }
  },
  async logOut({ commit }) {
    try {
      await request({
        url: "/auth/logout/",
        noAuthRedirect: true,
      });
      commit("SET_TOKEN", null);
    } catch (error) {
      // do nothing
    }
    window.location.reload();
  },
  async renewToken({ commit }, options = {}) {
    const { data } = await request.post(
      "/oauth/issue-token/",
      "grant_type=refresh_token",
      {
        ...options,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    commit("SET_TOKEN", data.access_token);
    return data;
  },
};

const getters = {
  isAuthorized(state) {
    return state.access_token && state.user?.id;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
